import React, { Component } from 'react';
import {Howl, Howler} from 'howler';

import './InteractionMask.css';
import './transitions.css';

import {    initRequestAnimFrame,
    getGesturePointFromEvent } from './Tools.js'

const _TOLERANCE_P = 0.15;   // valeur de tolerance en pourcentage de différence (au pif) avec l'imageData grabé
const _DIST_ECHT = 32;      // distance d'échantillonnage pour remplir _current (ex. 1 pixel sur N=32 : 1024/32 = 32 pixels width)
const _SIZE_POINT = 50;


class InteractionMask extends Component {

    constructor(props) {

        super(props);       

        this.canvas = null;
        this.setCanvas = element => {
            this.canvas = element;
        };            

        this.handleGestureStart = this.handleGestureStartFn.bind(this);
        this.handleGestureEnd = this.handleGestureEndFn.bind(this);
        this.handleGestureMove = this.handleGestureMoveFn.bind(this);             
        
        this.imgLoad = false;

        this.touchPos = null;
        this.isDrawFinish = false;

        this.loop_sound = false;
        this.sound_mp = false;
    }

    componentDidMount() 
    {
        initRequestAnimFrame();       
        

        // Add Touch Listener
        this.canvas.addEventListener('touchstart', this.handleGestureStart, false);
        this.canvas.addEventListener('touchmove', this.handleGestureMove, false);
        this.canvas.addEventListener('touchend', this.handleGestureEnd, false);
        this.canvas.addEventListener('touchcancel', this.handleGestureEnd, false);

        // Add Mouse Listener
        this.canvas.addEventListener('mousedown', this.handleGestureStart, false);
        
        this.touchPos = null;
        this.isDrawFinish = false;        

        /* resise canvas 1x1 pixels */

        // look up the size the canvas is being displayed
        const width = this.canvas.clientWidth;
        const height = this.canvas.clientHeight;
         
        // If it's resolution does not match change it
        if (this.canvas.width !== width || this.canvas.height !== height) {
            this.canvas.width = width;
            this.canvas.height = height;
        }

        this.props.logFn('InteractionMask:componentDidMount() canvas w: '+this.canvas.width+" h: "+this.canvas.height);

        /* init rendering du canvas pour l'app */

        let ctx = this.canvas.getContext('2d');
        if(ctx)
        {
            //console.log(ctx);

            ctx.globalCompositeOperation = 'source-over';    
            ctx.clearRect(0, 0, width, height);    /* FIXME() fixed size */

            let img = new Image();
            img.onload = () => {

                this.props.logFn('  InteractionMask:componentDidMount onLoad: '+img.src);

                ctx.drawImage(img, 0, 0, width, height);   
                ctx.globalCompositeOperation = 'destination-out';   
                
                this.imgLoad = true;
            }
            img.src = this.props.foregroundImage;
        }else
        {
            this.props.logFn('InteractionMask:componentDidMount() !!! CANVAS CONTEXT ERROR !!!');
        }

        /* launch sound */

        // conversion de background.jpg en background.mp3
        let straudio = this.props.backgroundImage.replace('.jpg','.mp3');

        this.loop_sound = new Howl({
            src: straudio,
            autoplay: true,
            loop: true,
          });      
        this.loop_sound.play();       
        
        // cas particulier du tunnel sous la manche
        if(this.props.backgroundImage.indexOf("11") > 0)
        {
            // pour récupérer le path
            let straudio = this.props.backgroundImage.replace('background.jpg',"marteau-piqueur.mp3");
            this.sound_mp = new Howl({ src: straudio, loop: true });      
          
        }

    }    


    componentWillUnmount()
    {
        // Remove Touch Listener
        this.canvas.removeEventListener('touchstart', this.handleGestureStart);
        this.canvas.removeEventListener('touchmove', this.handleGestureMove);
        this.canvas.removeEventListener('touchend', this.handleGestureEnd);
        this.canvas.removeEventListener('touchcancel', this.handleGestureEnd);

        // Remove Mouse Listener
        this.canvas.removeEventListener('mousedown', this.handleGestureStart);
        
        this.imgLoad = false;

        if(this.loop_sound)
        {
            this.loop_sound.unload();
            this.loop_sound = false;
        }
        if(this.sound_mp)
        {
            this.sound_mp.unload();
            this.sound_mp = false;
        }        

    }
        
    
    componentDidUpdate(prevProps, prevState, snapshot)
    {

        if( prevProps.menuOpen !== this.props.menuOpen)
        {
            if(this.props.menuOpen)
            {
                if(this.loop_sound) this.loop_sound.pause();
            }else
            {
                if(this.loop_sound) this.loop_sound.play();            
            }
        }
    }


/* ----------------------------------------------- */

    // Handle the start of gestures
    handleGestureStartFn(evt) {
        evt.preventDefault();

        if(!this.imgLoad) return;

        //console.log("##handleGestureStartFn");

        //if(evt.touches && evt.touches.length > 1)   return;
    
        // Add the move and end listeners
       if (this.canvas){
            // Add Mouse Listeners
            this.canvas.addEventListener('mousemove',this.handleGestureMove, false);
            this.canvas.addEventListener('mouseup', this.handleGestureEnd, false);
        }

        if(this.sound_mp)   this.sound_mp.play();
    
        this.touchPos = getGesturePointFromEvent(evt);    
        /* correction suite au passage responsive */
        /* il faut décaler point.x/y de la position du client */        
        const rect = evt.target.getBoundingClientRect();
        this.touchPos.x -= rect.left; 
        this.touchPos.y -= rect.top;  
            
    };

    // Handle end gestures
    handleGestureEndFn(evt) {
        evt.preventDefault();

        if(!this.imgLoad) return;

        //console.log("##handleGestureEndFn");

        // Remove Event Listeners
        if (this.canvas){
            // Remove Mouse Listeners
            this.canvas.removeEventListener('mousemove', this.handleGestureMove, false);
            this.canvas.removeEventListener('mouseup', this.handleGestureEnd, false);
        }

        if(this.sound_mp)   this.sound_mp.stop();
    
        this.touchPos = null;
    }

    handleGestureMoveFn(evt) {
        evt.preventDefault();

        if(!this.imgLoad) return;

        //console.log("##handleGestureMoveFn");
      
        if(!this.touchPos)  return;
      
        if(this.isDrawFinish)  return;
        this.touchPos = getGesturePointFromEvent(evt);
        /* correction suite au passage responsive */
        /* il faut décaler point.x/y de la position du client */        
        const rect = evt.target.getBoundingClientRect();
        this.touchPos.x -= rect.left; 
        this.touchPos.y -= rect.top;  

        //console.log("handleGestureMoveFn",this.touchPos);

        window.requestAnimFrame(this.drawPoint);        
        //this.drawPoint( this.touchPos.x,  this.touchPos.y);      
      
    }

    /* --------------------------------------------- */

    drawPoint = () => /* exececute via requestAnimFrame() */
    {
    
      if(!this.canvas) return;
      var ctx = this.canvas.getContext('2d');
      if(!ctx)  return;

      if(!this.touchPos)  return;

      const x = this.touchPos.x / this.props.scale;     /* il faut scaler, suiste au passage en responsive:  */
      const y = this.touchPos.y / this.props.scale;     /* les coordonnées sont en écran (scalée down ou up), et le canvas ou on dessine est fixed 1920x1080  */

      ctx.fillStyle = "black";  // Variante pour un dessin avec un touch flat 
      ctx.beginPath();
      let sp = _SIZE_POINT;
      if(this.props.sizePoint) sp = this.props.sizePoint;
      ctx.arc(x,  y, sp, 0, Math.PI*2,true);
      ctx.fill();
      ctx.closePath();


      // 
      if( this.full_amount(_DIST_ECHT) <= (_TOLERANCE_P/100))
      {
        this.isDrawFinish = true;
        this.touchPos = null;
        
        if(this.props.onEnd)
            this.props.onEnd();
        else
            this.props.logFn('InteractionMask:drawPoint() !!! Pas de fonction de sortie onEnd() !!!');
            
      }      
    }  


    full_amount = (stride) =>
    {
      var i, l;
     
      if(!this.canvas) return;
      var ctx = this.canvas.getContext('2d');
      if(!ctx)  return;

      var count, total;
      var pixels, pdata;

      if (!stride || stride < 1) { stride = 1; }

      stride *= 4; // 4 elements per pixel

      pixels = ctx.getImageData(0, 0, this.canvas.width, this.canvas.height );  
      pdata = pixels.data;
      l = pdata.length; // 4 entries per pixel

      total = (l / stride)|0;

      for (i = count = 0; i < l; i += stride) {
        if (pdata[i] != 0)  count++;        
      }

      return count / total;
    }



    render() {

        //const {sizePoint, onEnd, logFn} = this.props;

        let style = { backgroundImage: 'url('+this.props.backgroundImage+')'}


        /* children = <Helper> */

        return <div className="InteractionMask">            
                <div key='msk_background' style={ style} className="msk_background">
                    <canvas key='msk_canvas' ref={ this.setCanvas }  className="msk_canvas" ></canvas>
                    {this.props.children}   
                </div>
                </div>

  }
  
}



//----------------------------------------------------------------------------

export default InteractionMask;



// WEBPACK FOOTER //
// ./src/InteractionMask.js